import React from "react";
import styled from "styled-components";
import { Select, Cascader as AntCascader } from "antd";

import colors from "constants/palette";

export default function App(props) {
  const { title, list, titlestyle, no_default } = props;

  return (
    <Container>
      {title && <Title style={titlestyle ? titlestyle : {}}>{title} :</Title>}

      <CustomSelect
        defaultValue={
          props?.defaultValue
            ? props.defaultValue
            : no_default !== "true"
            ? list[0].title
            : null
        }
        {...props}
        size="large"
      >
        {list &&
          list.map((item, key) => (
            <CustomOption value={item?.value ?? item.title ?? item} key={key}>
              {item?.title ? item.title : item}
            </CustomOption>
          ))}
      </CustomSelect>
    </Container>
  );
}
export function Cascader(props) {
  const { title, list, titlestyle, no_default } = props;

  return (
    <Container>
      {title && <Title style={titlestyle ? titlestyle : {}}>{title} :</Title>}

      <CustomCascader {...props} />
    </Container>
  );
}

const CustomSelect = styled(Select)`
  border-radius: 24px;
  min-width: 130px;
  max-width: 260px;

  direction: rtl;
  text-align: center;
  & .ant-select-selector {
    border-radius: ${({ borderradius }) =>
      borderradius ? borderradius : "24px"} !important;
    background: ${colors.white + "50"} !important;
    color: ${colors.dark};
  }
  & * {
    fill: ${colors.dark} !important;
  }
`;
const CustomCascader = styled(AntCascader)`
  direction: rtl;
  text-align: center;
  & .ant-select-selector {
    height: 40px !important;
    display: flex;
    align-items: center;
    border-radius: ${({ borderradius }) =>
      borderradius ? borderradius : "7px"} !important;
    background: ${colors.white + "50"} !important;
    color: ${colors.dark};
  }
  & * {
    fill: ${colors.dark} !important;
  }
`;
const CustomOption = styled(Select.Option)`
  text-align: center;
  align-items: center;
  display: flex;
  width: 100%;
  min-width: 100%;
  direction: rtl;
  justify-content: center;
  background: ${colors.white};
`;
const Container = styled.div`
  margin-top: 12px;
`;
const Title = styled.div`
  margin-right: 16px;
  margin-bottom: 10px;
`;
